import React from 'react';
import Spinner from './Spinner';

export default function Loading(props) {
  return (
  <div className='fixed inset-0 z-10 bg-sphericaSecondary bg-opacity-75'>
    <Spinner mensaje={props.mensaje} />
  </div>
  );
}
